import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL =
    import.meta.env.VITE_API_URL || "https://secureapi-prod.azurewebsites.net";

interface CandidateProfile {
    id: string;
    fullName: string;
    email: string;
}

export default function CandidateDashboard() {
    const [profile, setProfile] = useState<CandidateProfile | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/candidate/login");
            return;
        }

        const fetchProfile = async () => {
            try {
                const res = await fetch(`${API_URL}/api/candidate/me`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (!res.ok) throw new Error("Unauthorized or token expired");

                const data = (await res.json()) as CandidateProfile;
                setProfile(data);
            } catch (err) {
                console.error("Profile fetch failed:", err);
                localStorage.removeItem("token");
                navigate("/candidate/login");
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, [navigate]);

    if (loading) return <p className="p-6 text-center">Loading profile...</p>;

    return (
        <div className="max-w-lg mx-auto p-6 text-center">
            <h1 className="text-3xl font-bold mb-2">Welcome</h1>
            <p className="text-lg text-gray-700 mb-6">
                {profile?.fullName ? `👋 Hello, ${profile.fullName}!` : "Candidate"}
            </p>

            <div className="space-y-3">
                <button
                    className="bg-indigo-600 text-white px-5 py-2 rounded w-full"
                    onClick={() => navigate("/candidate/tests")}
                >
                    Start My Test
                </button>

                <button
                    className="bg-gray-200 text-gray-800 px-5 py-2 rounded w-full"
                    onClick={() => {
                        localStorage.removeItem("token");
                        navigate("/candidate/login");
                    }}
                >
                    Log Out
                </button>
            </div>
        </div>
    );
}
